import React, { useState } from 'react';

const fmt = (v) =>
  v === null || v === undefined
    ? '—'
    : `$${Number(v).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/* Celda de precio editable en línea. Vacío = campo no capturado (null). */
export const PricingCell = ({ value, onSave, testId, accentClass = 'text-[#E2EAF4]' }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  const start = () => {
    setDraft(value === null || value === undefined ? '' : String(value));
    setEditing(true);
  };

  const commit = async () => {
    const trimmed = draft.trim();
    const parsed = trimmed === '' ? null : Number(trimmed);
    if (trimmed !== '' && !Number.isFinite(parsed)) {
      setEditing(false);
      return;
    }
    setEditing(false);
    if (parsed === (value ?? null)) return;
    setSaving(true);
    await onSave(parsed);
    setSaving(false);
  };

  if (editing) {
    return (
      <input
        type="number"
        step="0.01"
        autoFocus
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') commit();
          if (e.key === 'Escape') setEditing(false);
        }}
        className="w-24 rounded border border-[#0066FF] bg-[#040810] px-2 py-1 text-right font-mono text-xs text-white outline-none"
        data-testid={`${testId}-input`}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={start}
      className={`w-full rounded px-1 py-0.5 text-right font-mono hover:bg-[#0066FF]/25 ${value === null || value === undefined ? 'text-[#5A7A9A]' : accentClass} ${saving ? 'opacity-50' : ''}`}
      data-testid={testId}
    >
      {saving ? '…' : fmt(value)}
    </button>
  );
};

export default PricingCell;
